import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface AddPositionWishToCandidateResponse extends BackendResponse {}
export interface AddPositionWishToCandidateParameters extends NextApiParams {
  positionType: number;
  level?: 0 | 1 | 2 | 3;
}

export const addPositionWishToCandidate = withNextApi<
  AddPositionWishToCandidateResponse,
  AddPositionWishToCandidateParameters
>("/cvp/CvpAddPositionWishToCandidate");
